import {
  GridCellParams,
  GridColDef,
  GridColTypeDef,
  GridFilterInputMultipleSingleSelect,
  GridFilterInputSingleSelect,
  GridFilterInputValue,
  GridFilterItem,
  GridFilterOperator,
} from "@mui/x-data-grid";

const findItemInArray: GridFilterOperator = {
  label: "Find",
  value: "find",
  getApplyFilterFn: (filterItem: GridFilterItem, column: GridColDef) => {
    if (!filterItem.field || !filterItem.value || !filterItem.operator) {
      return null;
    }

    return (value, row, column, apiRef): boolean => {
      const val: string[] = value as string[];
      if (val.length === 0) return false;
      return val.find((x) => x === filterItem.value) ? true : false;
    };
  },
  headerLabel: "find",
  InputComponent: GridFilterInputSingleSelect,
};

const matchMultipleWordInMeta: GridFilterOperator = {
  label: "Match each",
  value: "matchEach",
  getApplyFilterFn: (filterItem: GridFilterItem, column: GridColDef) => {
    if (!filterItem.field || !filterItem.value || !filterItem.operator) {
      return null;
    }

    return (value, row, column, apiRef): boolean => {
      const val: string = value as string;
      if (val.length === 0) return false;
      const valuesList = val.toLocaleLowerCase().split("-");
      const filterItemValues = filterItem.value.toLocaleLowerCase().split(" ");
      let match = true;
      for (let i = 0; i < filterItemValues.length; i++) {
        if (!valuesList.find((x) => x.match(new RegExp(filterItemValues[i])))) match = false;
      }
      return match;
    };
  },
  headerLabel: "Match each",
  InputComponent: GridFilterInputValue,
};

const includesAllWords: GridFilterOperator = {
  label: "Contains",
  value: "contains",
  getApplyFilterFn: (filterItem: GridFilterItem, column: GridColDef) =>
    !filterItem.field || !filterItem.value || !filterItem.operator
      ? null
      : (value, row, column, apiRef): boolean => (value as string)?.toString().includesAllWords(filterItem.value),
  headerLabel: "Contains",
  InputComponent: GridFilterInputValue,
};

const multiSelectOperator: GridFilterOperator = {
  value: "contains",
  getApplyFilterFn: (filterItem) => {
    return (value, row, column, apiRef) => {
      if (filterItem.value === undefined) return true;
      if (Array.isArray(value)) return value.includes(filterItem.value);
      else return value === filterItem.value;
    };
  },
};

export const customOperators = {
  findItemInArray,
  matchMultipleWordInMeta,
  includesAllWords,
  multiSelectOperator,
};
